import React, { useCallback } from 'react';
import { props as ramdaProps } from 'ramda';
import { DemoButton as GameDemoButton, PlayButton as GamePlayButton } from 'js/components/common/Game/Buttons';
import { usePortletConfig, usePortletSelector } from 'js/components/system/Portlet';
import { useGetTrackLaunchGameFromBI } from '../BICategories';

export const withLaunchGameProps = ({ mode }) => Wrapped => (props) => {
    const [
        gameFeed = ''
    ] = usePortletSelector(ramdaProps(['feedName', 'filters'])); // null-safe unlike `pick`
    const { reactPortletId: container, queryString } = usePortletConfig();
    const trackLaunchGameFromBI = useGetTrackLaunchGameFromBI();
    const { code } = props;

    const onGameLaunched = useCallback(() => {
        if (!mode) {
            return;
        }

        trackLaunchGameFromBI(code);
    }, [trackLaunchGameFromBI, code]);

    return (
        <Wrapped
            {...props}
            {...queryString && { queryString }}
            container={container}
            gameFeed={gameFeed}
            onGameLaunched={onGameLaunched}
        />
    );
};

export const PlayButton = withLaunchGameProps({ mode: 1 })(GamePlayButton);

export const DemoButton = withLaunchGameProps({ mode: 0 })(GameDemoButton);
